import { api } from "@api/api";
import { Company } from "@modules/companies/types";
import { CompanyFormValues } from "@modules/companies/validations";

export async function editCompanyService(id: string, data: Partial<CompanyFormValues>): Promise<Company> {
  const { logo, cover_photo, ...body } = data;

  const payload: Partial<CompanyFormValues> = { ...body };

  if (!(logo instanceof File)) {
    payload.logo = null;
  }

  if (!(cover_photo instanceof File)) {
    payload.cover_photo = null;
  }

  const { data: company } = await api.patch<Company>(`v1/company_admin/${id}/`, payload);

  if (logo instanceof File || cover_photo instanceof File) {
    const formData = new FormData();

    if (logo instanceof File) {
      formData.append("logo", logo);
    }

    if (cover_photo instanceof File) {
      formData.append("cover_photo", cover_photo);
    }

    const { data: updatedCompany } = await api.patch<Company>(`v1/company_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return updatedCompany;
  }

  return company;
}
